import { gql } from 'graphql-tag';

import { ImageFragments } from './ImageType';

const pageId = gql`
  fragment PageId on Page {
    _id: externalId
    legacyId: id
  }
`;

const manageablePageStatusNodeFields = gql`
  fragment ManageablePageStatusNodeFields on Page {
    ...PageId
    name
    published
  }
  ${pageId}
`;

const manageablePageCoverImagesFields = gql`
  fragment ManageablePageCoverImagesFields on ImageRecordConnection {
    edges {
      node {
        ...ImageFields
      }
    }
  }
  ${ImageFragments.imageFields}
`;

export const PageFragments = {
  id: pageId,
  promotedCTANodeFields: gql`
    fragment PromotedCTANodeFields on PagesPromotedCallToAction {
      id
      headline
      subHeadline
      buttonText
      targetUrl
      image {
        url
        width
        height
      }
    }
  `,
  manageablePageCoverImagesFields,
  manageablePageNodeFields: gql`
    fragment ManageablePageNodeFields on Page {
      ...PageId
      logo(width: 340, height: 340) {
        ...ImageFields
      }
      coverImages(width: 480, last: 1) {
        ...ManageablePageCoverImagesFields
      }
      name
      published
      description
      promotedCallToActions(first: 1) {
        edges {
          node {
            id
            headline
            subHeadline
            targetUrl
            buttonText
            image {
              ...ImageFields
            }
          }
        }
      }
      pageable {
        ... on Brand {
          id
          externalId
          url
        }
      }
    }
    ${pageId}
    ${ImageFragments.imageFields}
    ${manageablePageCoverImagesFields}
  `,
  manageablePageStatusEdgeFields: gql`
    fragment ManageablePageStatusEdgeFields on PageEdge {
      node {
        ...ManageablePageStatusNodeFields
      }
    }
    ${manageablePageStatusNodeFields}
  `,
  manageablePageStatusNodeFields,
  discoveredBrandNodeFields: gql`
    fragment DiscoveredBrandNodeFields on Page {
      ...PageId
      displayName
      followedByCurrentUser
      followers {
        totalCount
      }
      logo(croppingStrategy: CENTER, height: 256) {
        url
      }
      coverImages(first: 1, croppingStrategy: CENTER, width: 400, height: 400) {
        edges {
          node {
            width
            height
            url
          }
        }
      }
    }
    ${pageId}
  `,
  allBrandsEntryFields: gql`
    fragment AllBrandsEntryFields on Page {
      id
      externalId
      displayName
    }
  `,
};
